import security from '../../../utils/security'

const state = {
  token: null,
  user: null
};

const mutations = {
  AUTHENTICATION_SET_DATA(state, payload){
    state.token = payload.token;
    state.user = payload.user;
  }
};

const getters = {
  userFullName: function(state) {
    if(state.user !== null){
       return state.user.name + ' ' + state.user.surname;
    }
    return '';
  },
  role: state => {
    if(state.user !== null){
      return state.user.roles;
    }
    return [];
  },
  isLogin: state => {
    if(state.user !== null ){
      return true;
    }
    return false;
  },
  checkPrivilege: (state, role) => {
    if(state.user !== null && state.user.roles.indexOf(role) > -1 ){
      return true;
    }
    return false;
  }
};

const actions = {
  logout() {
    security.logout();
  },
};


export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/security/authentication.js